import { Smartphone, Apple, ShoppingBag } from "lucide-react";

export default function AppDownload() {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="app-page">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="overline text-[#1a2d5e]">JAS Mobile App</div>
          <h1 className="font-display font-black text-5xl lg:text-6xl mt-3 text-[#0b1838] tracking-tighter">Shop &amp; track repairs on the go.</h1>
          <p className="mt-5 text-lg text-slate-600 max-w-lg">Browse products, book repairs, track trade-in offers, and get exclusive app-only deals. Coming to App Store and Google Play.</p>
          <div className="mt-8 flex flex-wrap gap-3">
            <button data-testid="app-ios-btn" className="inline-flex items-center gap-3 px-6 py-4 bg-[#0b1838] text-white rounded-lg hover:bg-[#1a2d5e] transition-colors">
              <Apple size={26} />
              <div className="text-left leading-tight">
                <div className="text-[10px] uppercase tracking-widest text-slate-300">Coming soon on</div>
                <div className="font-semibold">App Store</div>
              </div>
            </button>
            <button data-testid="app-android-btn" className="inline-flex items-center gap-3 px-6 py-4 bg-[#0b1838] text-white rounded-lg hover:bg-[#1a2d5e] transition-colors">
              <ShoppingBag size={24} />
              <div className="text-left leading-tight">
                <div className="text-[10px] uppercase tracking-widest text-slate-300">Coming soon on</div>
                <div className="font-semibold">Google Play</div>
              </div>
            </button>
          </div>
          <div className="mt-6 text-sm text-slate-500">Want to be notified at launch? Email <a className="underline text-[#1a2d5e]" href="mailto:info@jas-computers-mobiles.co.uk">info@jas-computers-mobiles.co.uk</a></div>
        </div>
        <div className="relative">
          <div className="absolute -inset-10 bg-[#aedfff]/40 rounded-[40px] rotate-6" />
          <div className="relative bg-gradient-to-b from-[#1a2d5e] to-[#0b1838] rounded-[40px] p-10 text-white text-center">
            <Smartphone size={64} className="mx-auto text-[#aedfff]" />
            <div className="mt-4 font-display font-black text-3xl">JAS</div>
            <div className="overline text-[#aedfff]">Unlimited Solutions</div>
            <div className="mt-12 text-sm text-slate-300">Beautiful · Fast · Always with you</div>
          </div>
        </div>
      </div>
    </div>
  );
}
